import { Component, OnInit, ViewChild, Injector } from '@angular/core';
import { Validators, FormControl, FormGroup, FormBuilder } from '@angular/forms';
import { Message, MenuItem, SelectItem, TreeNode } from 'primeng/components/common/api';
import { Utils } from '../../../../../utils';
import { UtenteService } from '../_service/UtenteService';
import { Utente } from '../_model/Utente';
import { query } from '@angular/animations/src/animation_metadata';
import { GenericComponent } from '../../../../layouts/custom-component/generic-component';
import { PageTableComponent } from '../../../../layouts/custom-component/page-table.component';

@Component({
    selector: ".m-grid__item.m-grid__item--fluid.m-wrapper",
    templateUrl: './utenti.component.html',

    providers: [
        { provide: String, useValue: "UtenteAF" }
    ]

})
export class UtentiComponent {

    tipologia: SelectItem[];
    item: Utente;
    itemName: string;
    cols: any[];
    loadTableStr: string;
    genericform: FormGroup;

    constructor(private fb: FormBuilder) {

    }

    ngOnInit() {

        this.item = new Utente();
        this.itemName = "utente";

        this.cols = [
            //{ field: 'id', header: 'id', sortable: true },
            { field: 'nome', header: 'Nome', sortable: true },
            { field: 'cognome', header: 'Cognome', sortable: true },
            { field: 'matricola', header: 'Matricola', sortable: true },
            // { field: 'password', header: 'Password', sortable: false },
            // { field: 'tipologia', header: 'Tipologia', sortable: true }
        ];




        this.genericform = this.fb.group({
            'id': new FormControl(''),
            'nome': new FormControl('', Validators.required),
            'cognome': new FormControl('', Validators.required),
            'matricola': new FormControl('', Validators.required),
            'password': new FormControl('', Validators.required)
            //    'email': new FormControl('', [Validators.required, Validators.email]),
            //  "tipologia": new FormControl('', Validators.required)

        });


    }








}





// WEBPACK FOOTER //
// ./src/app/theme/pages/default/cybersecurity/home/utenti.component.ts